import { useQuery } from '@tanstack/react-query';
import { yahooGetQuote, yahooGetQuotes, yahooGetHistory, type YahooInterval, type YahooRange } from '@/lib/yahooFinanceService';

/** Single live quote — 5 minute stale time */
export function useYahooQuote(ticker: string | undefined) {
  return useQuery({
    queryKey: ['yahoo-quote', ticker?.toUpperCase()],
    queryFn: () => yahooGetQuote(ticker!.toUpperCase()),
    enabled: !!ticker,
    staleTime: 5 * 60 * 1000,   // 5 minutes
    gcTime: 15 * 60 * 1000,     // 15 minutes
    retry: 1,
  });
}

/** Batch quotes for a list of tickers */
export function useYahooQuotes(tickers: string[]) {
  return useQuery({
    queryKey: ['yahoo-quotes', tickers.slice().sort().join(',')],
    queryFn: () => yahooGetQuotes(tickers),
    enabled: tickers.length > 0,
    staleTime: 5 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
    retry: 1,
  });
}

/** Historical price series for charts */
export function useYahooHistory(
  ticker: string | undefined,
  interval: YahooInterval = '1mo',
  range: YahooRange = '10y',
) {
  return useQuery({
    queryKey: ['yahoo-history', ticker?.toUpperCase(), interval, range],
    queryFn: () => yahooGetHistory(ticker!.toUpperCase(), interval, range),
    enabled: !!ticker,
    staleTime: 60 * 60 * 1000,  // 1 hour — historical data changes slowly
    gcTime: 4 * 60 * 60 * 1000,
    retry: 1,
  });
}
